import React from "react";
import "../css/SpecialOnboardScreeningCard.css";
import specialScreening from "../../../assets/images/special_screening_icon.svg";
import rightArrow from "../../../assets/images/right_arrow_icon.svg";

const SpecialOnboardScreeningCard = ({onClick}) => {
  return (
    <div className="trip-details-special-onboard-card" onClick={onClick} data-testid="special-onboard-screening-card">
      <div className="trip-details-special-onboard-card-container">
        <img
          src={specialScreening}
          alt="Special Onboard Icon"
          className="trip-details-special-onboard-card-icon"
          data-testid="special-onboard-screening-card-icon"
        />
      </div>
      <div className="trip-details-special-onboard-card-content">
        <h2 className="trip-details-special-onboard-card-title">
          Special Onboard Screening
        </h2>
      </div>
      <div className="trip-details-special-onboard-card-arrow" data-testid="special-onboard-screening-card-arrow">
        <img src={rightArrow} alt="right Arrow" />
      </div>
    </div>
  );
};

export default SpecialOnboardScreeningCard;
